// extracted by mini-css-extract-plugin
export default {"container":"Kacx+","share-icons":"lc0wO","shareIcons":"lc0wO","share-icon":"cRSkJ","shareIcon":"cRSkJ"};